export const appVersion = '5.9.28';


/** WEBPACK FOOTER **
 ** ./public/ts/app.version.ts
 **/